import React, { Component } from 'react'
import {withRouter} from 'react-router-dom'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import qs from 'qs'

import API from '../api'

import FaSearch from 'react-icons/fa/search'
import FaBuilding from 'react-icons/fa/building'

import './SearchInput.css'

const KEYS = {
  ENTER: 13,
  TAB: 9,
  UP_ARROW: 38,
  DOWN_ARROW: 40
}

@autobind
class SearchInput extends Component {
  constructor (props) {
    super(props)
    const url =  qs.parse(window.location.search, { ignoreQueryPrefix: true })
    let query = props.query || (url && url.lessonTitle)
    this.state = { query, seeds: [], keywords: [], schools: [], selectedIndex: 0 }
  }

  componentDidMount () {
    API.get('/v3/seed_search').then(({data}) => this.setState({ seeds: data }))
  }

  componentWillReceiveProps (props) {
    this.setState({query: props.query})
  }

  handleClick (e) {
    this.setState({keywords: this.state.seeds.slice(0, 5)})
  }

  handleKeyDown (e) {
    let { selectedIndex, keywords, schools } = this.state
    const suggestionLength = keywords.length + schools.length

    if ((selectedIndex && e.keyCode === KEYS.ENTER) || e.keyCode === KEYS.TAB) {
      e.preventDefault()
      selectedIndex <= keywords.length
        ? this.onKeywordClick(keywords[selectedIndex - 1].value)()
        : this.onSchoolClick(schools[selectedIndex - keywords.length - 1].value)()
    }

    e.keyCode === KEYS.UP_ARROW && this.setState({selectedIndex: selectedIndex ? (selectedIndex - 1) % suggestionLength : suggestionLength})
    e.keyCode === KEYS.DOWN_ARROW && this.setState({selectedIndex: selectedIndex + 1 === suggestionLength ? suggestionLength : (selectedIndex + 1) % suggestionLength})
  }

  onKeywordClick (query) {
    return () => this.props.onSubmit(query)
  }

  onSchoolClick (schoolId) {
    return () => {
      this.props.onChange('')
      this.props.history.push(`/schools/${schoolId}`)
    }
  }

  handleInputChange ({target: {value}}) {
    this.props.onChange(value)
    value.length && this.setState({keywords: this.state.seeds.filter(seed => seed.label.match(value)).slice(0, 5)})
    //value.length && API.get(`/v3/search_suggestions?search_term=${value}`).then(({data}) => this.setState({schools: data.suggestions.slice(0, 5)}))
    !value.length && this.setState({ schools: [], keywords: [] })
  }

  render () {
    let {keywords, schools, selectedIndex} = this.state
    var suggestionsSeeds = keywords.length
      ? <div>
        <div styleName='header'><FaSearch /> <span>Keywords:</span></div>
        <ul styleName='list'>{keywords.map((keyword, index) =>
          <li key={index} styleName={(selectedIndex === index + 1) ? 'selected' : ''} onClick={this.onKeywordClick(keyword.value)}>{keyword.label}</li>
        )}</ul>
      </div> : ''
    var suggestionsSchools = schools.length
      ? <div>
        <div styleName='header'><FaBuilding /> <span>Schools:</span></div>
        <ul styleName='list'>{schools.map((school, index) =>
          <li key={index} styleName={(selectedIndex === keywords.length + index + 1) ? 'selected' : ''} onClick={this.onSchoolClick(school.value)} dangerouslySetInnerHTML={{__html: school.label}} />
        )}</ul>
      </div> : ''

    const inputPlaceholder = 'Type to search'

    return (
      <div className='search-input'>
        <input type='text' id='searchInput' placeholder={inputPlaceholder} onClick={this.handleClick} onKeyDown={this.handleKeyDown} onChange={this.handleInputChange} defaultValue={this.state.query} autoComplete='off' />
        <div styleName='suggestions'>
          {suggestionsSeeds}
          {suggestionsSchools}
        </div>
      </div>
    )
  }
}

SearchInput.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  query: PropTypes.string,
  schoolId: PropTypes.string
}

export default withRouter(SearchInput)



// WEBPACK FOOTER //
// ./components/search/SearchInput.js